export default "__VITE_ASSET__BgmUmw8M__"